import React from 'react';

import {
  Box,
  styled
} from '@mui/material';

import { Timeline } from 'modules/layer00';
import { BaseWidget } from 'modules/layer01';
import * as dataService from './dataService';



const ContainerBox = styled(Box)({
  minWidth: 288
});



export interface IProps {
  orderId: string;
}

export const CustomerFC: React.FC<IProps> = props => {
  const queryTuple = dataService.useCustomerQuery(props.orderId);

  return (
    <FC
      data={queryTuple.data}
      orderId={props.orderId} />
  );
};

export const PartnerFC: React.FC<IProps> = props => {
  const queryTuple = dataService.usePartnerQuery(props.orderId);

  return (
    <FC
      data={queryTuple.data}
      orderId={props.orderId} />
  );
};



const FC: React.FC<{
  orderId: string;
  data: dataService.IData;
}> = props => {
  return (
    <>
      <ContainerBox>
        <BaseWidget.FC>
          <Timeline.FC steps={props.data.steps} />
        </BaseWidget.FC>
      </ContainerBox>
    </>
  );
};
